import { mergePageFieldMaps } from '@/common/utils/mergePageFieldMaps'
import { createSafeClientData } from '@/services/core/core.service'

type MinimalAppStore = {
  pagesData?: Record<string, unknown>
  setPageData?: (id: string, data: unknown) => void
}

export function seedDialogPageWithOutgoingFormFields(
  appStore: MinimalAppStore | null | undefined,
  formId: string,
  outgoingFlat: Record<string, unknown> | null | undefined,
): void {
  if (!appStore?.setPageData || !appStore.pagesData || !formId || !outgoingFlat) return
  const id = String(formId).trim()
  if (!id) return
  if (typeof outgoingFlat !== 'object' || Array.isArray(outgoingFlat)) return
  const keys = Object.keys(outgoingFlat)
  if (keys.length === 0) return

  const pageData = appStore.pagesData[id] as Record<string, any> | undefined
  if (!pageData || typeof pageData !== 'object') return

  let safeOutgoing: Record<string, any>
  try {
    safeOutgoing = createSafeClientData({ fields: outgoingFlat as Record<string, any> }).fields
      ?.fields || {}
  } catch {
    safeOutgoing = outgoingFlat as Record<string, any>
  }
  if (!safeOutgoing || typeof safeOutgoing !== 'object' || Object.keys(safeOutgoing).length === 0) {
    return
  }

  const serverUni = pageData.uniData?.fields?.fields || {}
  const serverChanged = pageData.jsResult?.changed_data?.fields?.fields || {}

  const mergedUni = mergePageFieldMaps(safeOutgoing, serverUni)
  const mergedChanged = mergePageFieldMaps(safeOutgoing, serverChanged)

  appStore.setPageData(id, {
    ...pageData,
    uniData: {
      ...pageData.uniData,
      fields: {
        ...pageData.uniData?.fields,
        fields: mergedUni,
      },
    },
    jsResult: {
      ...pageData.jsResult,
      changed_data: {
        ...pageData.jsResult?.changed_data,
        fields: {
          ...pageData.jsResult?.changed_data?.fields,
          fields: mergedChanged,
        },
      },
    },
  })
}
